import { ReactNode } from 'react';
import { useRouter } from 'next/router';

import PublicPage from '@/v2/components/Page/PublicPage/PublicPage';
import { BACKGROUND_VARIANTS } from '@/v2/components/Page/PublicPage/PublicPage.styled';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import CheckInbox from '@/v2/domains/Auth/pages/CheckInbox/CheckInbox';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';

interface EmailVerificationGateProps {
  children: ReactNode;
}

export default function EmailVerificationGate({
  children,
}: EmailVerificationGateProps) {
  const { user } = useCurrentUser();
  const { pathname } = useRouter();

  const isPathAvailable =
    emailVerificationConstants.pathsAvailableWhilePending.includes(pathname);

  if (!user?.emailVerificationPending || isPathAvailable) {
    return <>{children}</>;
  }

  return (
    <PublicPage backgroundVariant={BACKGROUND_VARIANTS.MAIN}>
      <CheckInbox />
    </PublicPage>
  );
}
